import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOccupancy,
  selectOccupancy,
  setDataSuccess
} from 'src/features/staticDataSlice';
import OccupencyCreateModal from 'src/pages/Occupancy/OccupencyCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function OccupancyList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [occupancyCreatePermission, setOccupancyCreatePermission] = useState(false);
  const [occupancyViewPermission, setOccupancyViewPermission] = useState(false);

  const occupancyData = useSelector(selectOccupancy);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) =>
      setOccupancyCreatePermission(permission)
    );
    checkPermission('riskFactors', 'view').then((permission) =>
      setOccupancyViewPermission(permission)
    );
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('occupancy', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchOccupancy(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'occupancy', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-occupancy" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-occupancy"
          id="select-occupancy"
          value={tableListDatas[index]?.occupancy || ''}
          onChange={(event) => {
            handleChange('occupancy', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {occupancyViewPermission &&
            occupancyData?.map((occupancy) => (
              <MenuItem key={occupancy?.occupancyName} value={occupancy?.occupancyName}>
                {occupancy?.occupancyName}
              </MenuItem>
            ))}
          <Tooltip
            title={
              occupancyCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Occupancy
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (occupancyCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: occupancyCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <OccupencyCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default OccupancyList;
